import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function RoleGuard({ roles, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" style={{ color: 'var(--heritage-plum)' }}>
        <div className="h-eyebrow">Loading…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    // send to their own console
    const dest = user.role === 'admin' ? '/admin' :
                 user.role === 'founder' ? '/console/founder' :
                 user.role === 'ambassador' ? '/console/ambassador' :
                 '/console/customer';
    return <Navigate to={dest} replace />;
  }
  return children || <Outlet />;
}
